import React from 'react'
import PropTypes from 'prop-types';
import Text from '../../form/form-text'
import DateTimePicker from '../../form/form-date-time-picker'
import Switch from '../../form/form-switch'

import '../module.styl'
class ModuleScheduling extends React.Component {
    constructor(props) {
        super(props)
        this.i18n = 'app.modules.components.scheduling.'
        this.state = {
            disabled: props.disabled,
            data: props.data
        }
    }

    onChange() {
        this.state.data.visibility = !this.state.data.visibility
        this.setState(this.state)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { i18n } = this;
        let { disabled=true } = this.state;

        return <div className="module module-scheduling">
            <Text disabled={disabled} onChange={this.onChange.bind(this)} value={this.state.data.name} label={i18n + 'title'} />
            <DateTimePicker disabled={disabled} onChange={this.onChange.bind(this)} date={new Date(this.state.data.startDate)} dateFormat={'HH:mm - DD MMMM YYYY'} label={i18n + 'date'} />
            <Switch disabled={disabled} onChange={this.onChange.bind(this)} checked={this.state.data.visibility} label={i18n + 'print'}/>
        </div>;
    }
}

ModuleScheduling.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    data: PropTypes.shape({
        name: PropTypes.string,
        startDate: PropTypes.string,
        visibility: PropTypes.bool
    })
}

export default ModuleScheduling
